var _path, _circle, _path2, _circle2, _circle3, _circle4, _circle5, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyRoulette = function SvgImgEmptyRoulette(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.682 70.364h23.182M27.136 75l13.137-40.182v0L53.409 75",
    stroke: "#BDBDBD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.273,
    cy: 34.818,
    r: 26.273,
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.273 11.636V58m11.591-43.258L28.682 54.894m31.667-31.667L20.197 46.41m43.258-11.592H17.09M60.349 46.41 20.197 23.226m31.667 31.668L28.682 14.742",
    stroke: "#BDBDBD",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.273,
    cy: 34.818,
    r: 14.682,
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    stroke: "#BDBDBD",
    strokeWidth: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.273,
    cy: 34.818,
    r: 8.5,
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.273,
    cy: 34.818,
    r: 2.318,
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.273,
    cy: 34.818,
    r: 23.182,
    stroke: "#BDBDBD",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.015 16.734c-.268.67-1.217.67-1.485 0L35.636 7h9.273l-3.894 9.734z",
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyRoulette);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-empty-roulette.4cc0e0e5f0a09ce3ac77c918068e43f4.svg";